import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionIssuesFilterOptionsQueryVariables } from '../MfaSessionIssuesFilterOptions.generated';

export const buildMfaSessionIssuesFilterOptionsVariables = (
	sessionId: string
): MfaSessionIssuesFilterOptionsQueryVariables => {
	return {
		runId: buildRunIdParam(sessionId).runId
	};
};
